import { Stack, Box, Paper, Button, CircularProgress } from "@mui/material";
import TitlePage from "@components/atoms/TitlePage/TitlePage";
import TitlePaper from "@components/atoms/TitlePaper/TitlePaper";
import InputText from "@components/atoms/InputText/InputText";
import { IEditClientUI } from "src/types/organisms";
import ErrorAlert from "@components/atoms/ErrorAlert/ErrorAlert";
import LoadingGif from "../../../assets/gifs/loading.gif";
import { useFormValidate } from "@utils/hooks";
const EditClientUI = ({
  register,
  onSubmit,
  loadingData,
  isLoading,
  errorMessage,
  showError,
  errors,
  closeError,
  handleCancelClick
}: IEditClientUI) => {
  const {
    validateField
  } = useFormValidate();
  return <>
      <TitlePage title="Editar cliente" subtitle="En la sección de edición de clientes, puedes actualizar datos como teléfono o correo electrónico." />
      <Paper elevation={12} sx={{
      width: 1,
      padding: "24px",
      marginTop: 3
    }} onKeyDown={e => e.key.toLowerCase() === "enter" ? onSubmit() : null}>
        <TitlePaper title="Información del cliente" subtitle="Detalle completo de este cliente." />
        {!loadingData && <Stack component="form" direction={"row"} justifyContent={"space-between"} alignItems={"flex-start"} marginTop={3} flexWrap={"wrap"} noValidate>
            <Box marginBottom={2} width={0.49}>
              <InputText label={"Nombre"} name={"fullName"} placeholder={"Ingresa el nombre"} register={register("fullName", {
            required: true
          })} helperText={validateField(errors?.fullName)} disabled={isLoading} />
            </Box>
            <Box marginBottom={2} width={0.49}>
              <InputText label={"Número de documento"} name={"identification"} placeholder={"Ingresa número de documento"} register={register("identification", {
            valueAsNumber: true
          })} helperText={validateField(errors?.identification)} disabled={isLoading} />
            </Box>
            <Box marginBottom={2} width={0.49}>
              <InputText label={"Teléfono"} name={"phone"} placeholder={"Ingresa número de teléfono"} register={register("phone", {
            required: true,
            valueAsNumber: true
          })} helperText={validateField(errors?.phone)} disabled={isLoading} />
            </Box>
            <Box marginBottom={2} width={0.49}>
              <InputText label={"Correo electrónico"} name={"email"} placeholder={"Ingresa correo electrónico"} register={register("email", {
            pattern: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/
          })} helperText={validateField(errors?.email)} disabled={isLoading} />
            </Box>
            <Box marginBottom={2} width={0.49}>
              <InputText label={"Cupo (opcional)"} name={"moneyCapAmount"} placeholder={"Ingresa el cupo del cliente"} register={register("moneyCapAmount", {
            valueAsNumber: true
          })} disabled={isLoading} type="number" />
            </Box>
          </Stack>}
        <Stack direction={"row"} justifyContent={"center"}>
          <Box component={"img"} display={loadingData ? "block" : "none"} src={LoadingGif} width={170} />
        </Stack>
      </Paper>
      <Stack direction={"row"} justifyContent={"flex-end"} marginTop={3} spacing={3}>
        <Button color="secondary" size="large" disabled={isLoading} onClick={handleCancelClick}>
          Cancelar
        </Button>
        <Button type="submit" size="large" onClick={isLoading ? () => null : onSubmit} endIcon={isLoading && <CircularProgress thickness={3} size={20} sx={{
        color: "white"
      }} />}>
          {isLoading ? "Guardando" : "Guardar cambios"}
        </Button>
      </Stack>
      <ErrorAlert open={showError} onClose={closeError} message={errorMessage} />
    </>;
};
export default EditClientUI;